<template>
  <div class="likert-answer-container">
    <div class="question-stem">{{question.Question}}</div>
    <div class="num-responses">{{question.responses.length}} responses</div>
    <BarChart :question="question" />
  </div>
</template>

<script>
import BarChart from "./BarChart.vue";
export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  components: {
    BarChart
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  width: 80%;
  font-size: 1em;
  text-align: justify;
  color: #000000;
  margin-bottom: 0.75em;
  margin-left: 0.5em;
  line-height: 1.2;
}
.num-responses {
  font-family: Arial;
  font-size: 1em;
  color: #2c557d;
  margin: 0.5em;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    width: 80%;
    font-size: 1.25em;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.75em;
    margin-left: 0.5em;
    line-height: 1.2;
  }
}
</style>